<template>
    <div class="menus__component">
        <div class="content" :class="{ show: $store.state.showSideBar }">
            <a
                v-for="item in listItems"
                :key="item.route"
                :class="menuClass(item)"
                style="cursor: pointer"
                @click="clickMenuItem(item)"
            >
                <img
                    v-if="!$store.state.showSideBar"
                    :src="item.icon"
                    class="mr-2"
                    onload="SVGInject(this)"
                    width="12%"
                />
                <p :class="{ 'd-none': $store.state.showSideBar }">
                    {{ item.name }}
                </p>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        listItems: {
            type: Array,
            required: true,
            validator: function (listItems) {
                if (listItems.length == 0) {
                    console.error("listItems cannot be empty");
                    return false;
                }

                let optionKeys;
                const listItemsLength = listItems.length;
                for (let i = 0; i < listItemsLength; i++) {
                    let option = listItems[i];
                    optionKeys = Object.keys(option);

                    const requiredObjectProps = ["name", "route", "icon"];

                    if (optionKeys.length < requiredObjectProps.length) {
                        console.error(
                            "listItems must contain the props [" +
                                requiredObjectProps +
                                "]"
                        );
                        return false;
                    }

                    const requiredObjectPropsLength =
                        requiredObjectProps.length;
                    for (let j = 0; j < requiredObjectPropsLength; j++) {
                        const requiredProp = requiredObjectProps[j];

                        if (!optionKeys.includes(requiredProp)) {
                            console.error(
                                "listItems must contain the prop => " +
                                    requiredProp
                            );
                            return false;
                        }
                    }
                }

                return true;
            },
        },
    },
    methods: {
        clickMenuItem(item) {
            this.$store.commit("backofficeNavigation/reset");
            if (item.route) {
                this.$router.push({ name: item.route });
            }
        },
        menuClass(item) {
            return `${item.route} ${
                this.$route.path.includes(
                    this.$router.resolve({ name: item.route }).href
                )
                    ? "router-link-exact-active router-link-active"
                    : ""
            }`;
        },
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";

.menus__component {
    .content {
        padding: 15px;

        &.show {
            //padding-left: 70%;

            a {
                padding: 2px 6px 2px 15px;
                svg {
                    width: 100% !important;
                }
            }
        }

        a {
            font-family: Lato;
            display: flex;
            align-items: center;
            padding: 15px 10px;
            margin: 10px 0;
            border-radius: 7.5px;
            text-decoration: none;
            color: $grey-dark;
            transition: $animations-time-duration ease;

            &:hover {
                background-color: $grey;
                color: $white;
                text-decoration: none;
            }

            span {
                margin-right: 5px;
            }

            p {
                margin: 0;
            }

            &.router-link-exact-active.router-link-active {
                background-color: var(--v-primary-base);
                color: $white;

                svg {
                    path:last-child {
                        fill: $white;
                    }
                }
            }

            &.show {
                width: 10%;
            }
        }

        .backoffice-business-indicators {
            &:hover,
            &.router-link-exact-active.router-link-active {
                svg {
                    path {
                        stroke: $white;
                        fill: $white !important;
                    }
                }
            }
        }

        .backoffice-entities {
            &:hover,
            &.router-link-exact-active.router-link-active {
                svg {
                    g g g {
                        path {
                            stroke: $white !important;
                            fill: $white !important;
                        }
                    }
                }
            }
        }

        .backoffice-users,
        .backoffice-definitions {
            &:hover,
            &.router-link-exact-active.router-link-active {
                svg {
                    path {
                        stroke: $white;
                    }
                }
            }
        }

        .backoffice-tecdoc-catalogue {
            &:hover,
            &.router-link-exact-active.router-link-active {
                svg {
                    .st0tecdoc,
                    .st1tecdoc,
                    .st2tecdoc,
                    .st3tecdoc,
                    .st4tecdoc,
                    .st5tecdoc,
                    .st6tecdoc,
                    .st7tecdoc {
                        stroke: #fff;
                    }

                    .st2tecdoc,
                    .st5tecdoc {
                        fill: #4b4849;
                    }

                    .st3tecdoc,
                    .st6tecdoc {
                        fill: #fff;
                    }
                }
            }
        }

        .backoffice-mytips {
            &:hover,
            &.router-link-exact-active.router-link-active {
                .st0300 {
                    stroke: $white;
                }
            }
        }
    }
}
</style>
